import React from 'react'
import Header from '../Header/Header'
import Footer from '../Footer/Footer'
import cardframe1 from '../../assets/images/cardframe1.png'
import cardframe2 from '../../assets/images/cardframe2.png'
import cardframe3 from '../../assets/images/cardframe3.png'
import './ChatWithData.css'

function ChatWithData() {
    const capabilities = [
        { icon: "💬", text: "Natural Language Queries" },
        { icon: "📜", text: "Contextual Threads" },
        { icon: "🔒", text: "Secure, Compliant, Private" },
        { icon: "⭐", text: "Saved Prompts" },
        { icon: "📊", text: "Export to CSV, Excel, PDF" },
        { icon: "📚", text: "Model Stack: GPT, Claude, DeepSeek" },
    ];
    return (
        <div className="home">
            <Header />
            <div className='banner-section d-flex flex-column align-items-center justify-content-center ' style={{ gap: '24px' }}>
                <h1 className="banner-title w-75">Ask. Analyze. Act.</h1>
                <p className="banner-description">
                    Chat in plain English to explore data, build answers, and trigger follow-ups. Your AI Superagent makes it feel effortless.
                </p>
                <div className='d-flex gap-3'>
                    <button className="theme-rounded-btn" style={{ padding: '16px 24px' }}>Start New Chat</button>
                    <button className="theme-rounded-outline-btn" style={{ padding: '16px 24px' }}>Try On Sample Data</button>
                </div>
            </div>

            <div className='cards-section'>
                <h3 style={{fontSize:'45px'}}>Why It Matters</h3>
                <div className='d-flex gap-24 w-100 card-container'>
                    <div className='card-section'>
                        <h4 style={{ color: "#191C20" }}>🧠 Clarity Fast</h4>
                        <h5>No SQL required. BrainyAgent writes the queries for you.</h5>
                    </div>
                    <div className='card-section'>
                        <h4 style={{ color: "#191C20" }}>🔁 Context-Aware</h4>
                        <h5>Follow-up questions refine results inside the same thread.</h5>
                    </div>
                    <div className='card-section'>
                        <h4 style={{ color: "#191C20" }}>✅ From Insight to Action</h4>
                        <h5>Save prompts, schedule refreshes, and export results.</h5>
                    </div>
                </div>
            </div>

            <div className="card-frame d-flex flex-column" style={{ padding: '64px 200px', gap: '48px' }}>
                <h3>How It Works</h3>
                <div className="row w-100">
                    <div className="col-12 col-md-4 p-3">
                        <div className="card h-100 shadow-sm d-flex flex-column justify-content-between rounded-4 overflow-hidden">
                            <div className="card-body">
                                <h5 className="fw-bold">Step 1</h5>
                                <p className="text-muted">
                                    Connect a data source or upload a file.
                                </p>
                            </div>
                            <div className="text-center">
                                <img
                                    src={cardframe1}
                                    alt="Step 1"
                                    className="img-fluid w-100 rounded-bottom-4"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-4 p-3">
                        <div className="card h-100 shadow-sm d-flex flex-column justify-content-between rounded-4 overflow-hidden">
                            <div className="card-body">
                                <h5 className="fw-bold">Step 2</h5>
                                <p className="text-muted">
                                    Ask a natural-language question (e.g., “Q4 vs Q3 revenue”).
                                </p>
                            </div>
                            <div className="text-center">
                                <img
                                    src={cardframe2}
                                    alt="Step 2"
                                    className="img-fluid w-100 rounded-bottom-4"
                                />
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-md-4 p-3">
                        <div className="card h-100 shadow-sm d-flex flex-column justify-content-between rounded-4 overflow-hidden">
                            <div className="card-body">
                                <h5 className="fw-bold">Step 3</h5>
                                <p className="text-muted">
                                    Get a table or chart you can iterate on.
                                </p>
                            </div>
                            <div className="text-center">
                                <img
                                    src={cardframe3}
                                    alt="Step 3"
                                    className="img-fluid w-100 rounded-bottom-4"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="card-frame w-100 d-flex flex-column" style={{ padding: '64px 200px', gap: '48px' }}>
                <h3>Core Capabilities</h3>
                <div className="capabilities-grid">
                    {capabilities.map((cap, i) => (
                        <div key={i} className="capability-card">
                            <span className="icon">{cap.icon}</span>
                            <span >{cap.text}</span>
                        </div>
                    ))}
                </div>
            </div>
            <div className='banner-section d-flex flex-column align-items-start justify-content-start ' style={{ gap: '24px',padding:'64px 200px' }}>
                <h1 className="banner-title text-start w-75" style={{fontSize:'45px'}}>Ask. Analyze. Act.</h1>
                <p className="banner-description text-start w-100">
                    Chat in plain English to explore data, build answers, and trigger follow-ups. Your AI Superagent makes it feel effortless.
                </p>
                <div className='d-flex gap-3'>
                    <button className="theme-rounded-btn" style={{ padding: '16px 24px' }}>Start New Chat</button>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default ChatWithData